import React from 'react';
import cx from 'classnames';
import styles from './AppComponent.module.scss';
import { Icon } from '../Icon';
import Well from '../Well/Well';
import { CustomButton } from '../Button/Button';
import { useTranslation } from 'react-i18next';

const androidAppUrl = 'https://play.google.com/store/apps/details?id=nl.vormats.store';
const iosAppUrl = 'https://apps.apple.com/us/app/vormats-video-storyteller/id1535842366?uo=4&at=1010lpjB&ct=tas';

const AppComponent = ({ handleNextStep, disableNext, loading }) => {
  const { t } = useTranslation();

  return (
    <div id="step2">
      <h1 className={styles.title}>{t('download.chrome_extension.title')}</h1>

      <div className="flex-center">
        <div className={cx(styles.qrCard, 'auth-card')}>
          <Icon src="QRCode" />
        </div>
      </div>

      <div className={styles.cardContainer}>
        <div className={styles.onboardingCard}>
          <div className={styles.onboardingDescription}>
            <Well
              title={t('download.chrome_extension.android_app.title')}
              body={t('download.chrome_extension.android_app.subtitle')}
              icon="android"
              btnType="android"
              btnLink={androidAppUrl}
              handleNextStep={handleNextStep}
            />
            <Well
              title={t('download.chrome_extension.ios_app.title')}
              body={t('download.chrome_extension.ios_app.subtitle')}
              icon="ios"
              btnType="ios"
              btnLink={iosAppUrl}
              handleNextStep={handleNextStep}
            />
          </div>
          <div>
            <CustomButton
              className={cx(
                {
                  submit: !disableNext && !loading,
                  'no-submit': disableNext || loading,
                },
                'next'
              )}
              variant={'primary'}
              onClick={handleNextStep}
              loading={loading}
              loadingText="Moving to next step"
              label={t('download.chrome_extension.button.next')}
              customStyles={{ width: '160px', justifyContent: 'center' }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
export default AppComponent;
